/*
 * @format
 */

import React from 'react';

import WatchZoneTapDiagram from './WatchZoneTapDiagram';
import { modePillFor } from './WatchFace';

/* The zone screen with the mode pill picked out as the thing to press. */
function WatchModeTapDiagram() {
  return (
    <WatchZoneTapDiagram
      boxFor={modePillFor}
      clipId="mode-tap-face"
      description={
        'A watch zone screen with the heating mode beneath the temperature ' +
        'highlighted. A line points to a fingertip on it.'
      }
    />
  );
}

export default WatchModeTapDiagram;
